export function positiveIntegerParser(val: string): number {
  const value: number = parseInt(val, 10);
  if (!Number.isNaN(value) && 0 < value) return value;
  return 0;
}
